<template>
  <form @submit.prevent="saveForm()">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head flex justify-between">
        <p class="modal-card-title">
          {{ user ? 'Update User' : 'Add User' }}
        </p>
        <d-switch v-model="userForm.active" color="green-500" class="font-weight-normal text-base">
          Active
        </d-switch>
      </header>
      <section class="modal-card-body">
        <d-field label="Username*">
          <d-input v-model="userForm.userName" required />
        </d-field>
        <d-field label="System email*">
          <d-input v-model="userForm.systemEmail" type="email" required />
        </d-field>
        <d-field v-if="!userForm.sendPasswordInEmail" label="Password*">
          <d-input v-model="userForm.password" type="password" :required="!user" />
        </d-field>
        <d-field v-if="!user" label="Send welcome email with autogenerated password">
          <d-checkbox v-model="userForm.sendPasswordInEmail" />
        </d-field>
        <d-field v-if="user && userForm.password" label="Send new password to user in email">
          <d-checkbox v-model="userForm.sendResetPasswordInEmail" />
        </d-field>
        <d-field label="First Name*">
          <d-input v-model="userForm.firstName" required />
        </d-field>
        <d-field label="Last Name*">
          <d-input v-model="userForm.lastName" required />
        </d-field>

        <d-field label="User Roles" class="flex-1 mt-3 block">
            <d-checkbox v-model="userForm.roles" native-value="Mentee">
                Mentee
            </d-checkbox>
            <d-checkbox v-model="userForm.roles" native-value="Mentor">
                Mentor
            </d-checkbox>
            <d-checkbox v-model="userForm.roles" native-value="Consultant">
                Consultant
            </d-checkbox>
            <d-checkbox v-model="userForm.roles" native-value="CTE Admin Discussions">
                CTE Admin Discussions
            </d-checkbox>
        </d-field>
        <d-field label="Admin. Roles" class="flex-1 mt-3 block">
          <d-checkbox v-model="userForm.roles" native-value="System Administrator">
            System Administrator
          </d-checkbox>
        </d-field>
      </section>
      <footer class="modal-card-foot justify-end">
        <d-btn flat @click="$parent.close()">
          Cancel
        </d-btn>
        <d-btn :loading="saving" type="submit">
          {{ user ? 'Update User' : 'Add User' }}
        </d-btn>
      </footer>
    </div>
  </form>
</template>
<script>
  import axios from 'axios';
  import debounce from 'lodash/debounce';

  export default {
    props: {
      user: {
        type: Object,
        default: () => { },
      },
    },
    data: () => ({
      saving: false,
      communities: [],
      selectedCommunity: '',
      userForm: {
        firstName: '',
        lastName: '',
        systemEmail: '',
        password: '',
        username: '',
        roles: [],
        sendPasswordInEmail: false,
        sendResetPasswordInEmail: false,
        active: true,

      },
      users: [],
      organizations: [],
    }),

    mounted() {
      if (this.user) {
        this.userForm = JSON.parse(JSON.stringify(this.user));
      }
    },
    methods: {
      async saveForm() {
        this.saving = true;
        try {
          if (this.user) {
            this.userForm.sendPasswordInEmail = false;
            await axios.patch(`/api/admin/users/${this.userForm.id}`, this.userForm);
          } else {
            await axios.post('/api/admin/users/', this.userForm);
          }
          await this.$parent.events.getUsersPaged();
          this.$parent.close();
        } catch (error) {
          this.$toast.open({ message: error.response.data[0], color: 'red-500', duration: 4000 });
        } finally {
          this.saving = false;
        }
      },

      getCommunitiesDataAsync: debounce(async function (name) {
        if (!name.length) {
          this.users = [];
          return;
        }
        this.isFetching = true;
        try {
          const { data } = await axios.get(`/api/admin/communities/paged?currentPage=1&pageSize=5&filter=${name}`);
          this.users = [];
          this.selectedCommunity = '';
          data.resultItems.forEach((item) => this.communities.push(item));
        } catch (error) {
          this.communities = [];
          throw error;
        } finally {
          this.isFetching = false;
        }
      }, 500),

      resetSelectedCommunity() {
        this.selectedCommunity = '';
      },
      setSelectedCommunity(community) {
        this.communities.push(community);
      },
    },
  };
</script>